/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import cn from 'classnames';
import Slider from './Slider';
import BottomInfo from './BottmInfo';

interface Props {
  className?: string;
}

const Main: React.FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        className,
        'min-h-screen max-w-screen-lg text-center text-black mx-auto',
      )}>
      <div className=" pt-28 pb-12 px-6">
        <b>T I T L E</b>
        <p className="py-4">어떤 말을 넣지?!!?!?!?!</p>
      </div>
      <Slider height="small" />
      <BottomInfo className="mt-40 mb-8" />
    </div>
  );
};

export default Main;
